var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"name":_vm.compLabel,"rules":_vm.compValidator,"vid":_vm.id},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('v-select',_vm._g(_vm._b({attrs:{"error-messages":errors,"id":_vm.id,"label":_vm.compLabel,"name":_vm.vid,"prepend-icon":_vm.icon,"value":_vm.value}},'v-select',_vm.$attrs,false),_vm.$listeners))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }